import { jsx as _jsx } from "react/jsx-runtime";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { useTranslations } from "@jti/ui";
import { useAddProduct } from "../../hooks/useAddProduct";
import AddToCartButton from "./AddToCartButton";
const TryBundleButton = ({ sku, bundle, onError, isLoaded }) => {
    const { __ } = useTranslations();
    const { isRunning, addProductToCart } = useAddProduct(sku, bundle, true, onError);
    const isLoading = isRunning || !isLoaded;
    const startFreeTrial = () => {
        dispatchTrackingEvent(TrackingEvents.TrackingFreeTrialStart);
        addProductToCart();
    };
    return (_jsx(AddToCartButton, { onClick: startFreeTrial, isLoading: isLoading, testId: "pdpTryBundle", label: __("product.button.trynow") }));
};
export default TryBundleButton;
//# sourceMappingURL=TryBundleButton.js.map